module.exports = __webpack_public_path__ + "damir-bosnjak.jpg?a6f24e7dd5470a8bd2f48ebb53dbe8d5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/damir-bosnjak.jpg
// module id = 308
// module chunks = 0